/* eslint-disable */
define(function () {
    /**
    * @title    - Viewport Module
    * @desc     - Overall code for viewport module
    * @param    - none
    * @return   - object with public functions and/or variables
    */
    Viewport = (function() {

        // declare private global variables for this module
        var breakpoint = {};


        /**
        * @title    - Environment Function
        * @desc     - Get the current viewport from body:before
        * @param    - none
        * @return   - string of current viewport (like lg)
        */
        var environment = function() {
            breakpoint.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
            return breakpoint.value;
        };



        /**
        * @title    - Bindevents Function
        * @desc     - Initialize the binding events.
        * @param    - none
        * @return   - none
        */
        var bindEvents = function() {
        };


        /**
        * @title    - Init Function
        * @desc     - Initialize the module with calling the standard methods.
        * @param    - none
        * @return   - none
        */
        var init = function() {

            // init Viewport slider
            environment();

            // init bindevents
            bindEvents();

        };


        // return public functions and/or variables to use in other modules
        return {
            init: init,
            environment: environment,
        };


    }());

    Viewport.init();
});


// WEBPACK FOOTER //
// ./scripts/legacy/modules/viewport.js